import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageHeader } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { DISPLAY_MODE } from "Constants";
import { useStoreState } from "easy-peasy";
import FourOThree from "Pages/private/403";
import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { GenerateBackPath } from "Utils";
import moment from "moment";
import PartnerForm from "../components/form";
import UnitForm from "../components/form";

export default function NewUnitPage({ ...props }) {
  const history = useHistory();
  const match = useRouteMatch();

  const [unit, setUnit] = useState({
    address: "",
    code: null,
    description: "",
    district: "",
    measures: [],
    neighborhood: "",
    province: "",
    version: 0,
  });
  const { abilities } = useStoreState((store) => store.auth);

  return (
    <>
      <PageHeader
        className="customized"
        backIcon={<FontAwesomeIcon icon={["fas", "chevron-left"]} />}
        onBack={() => {
          history.push(GenerateBackPath(match.path, 4));
        }}
        title={"Yeni Birim"}
      />
      {AuthCheck(abilities, AUTH_ACTIONS.NEW_RECORD, "Birimler") ? (
        <UnitForm
          mode={DISPLAY_MODE.NEW}
          unit={unit}
          onAfterSuccess={(response) => {
            history.push(
              `${GenerateBackPath(match.path, 4)}/${response?.id}/detay`
            );
          }}
        />
      ) : (
        <FourOThree />
      )}
    </>
  );
}
